import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-helpbutton-department',
  templateUrl: './helpbutton-department.component.html',
  styleUrls: ['./helpbutton-department.component.scss']
})
export class HelpbuttonDepartmentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
